package com.hyperether.goodjob.scenes.jobs

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Divider
import androidx.compose.material.IconButton
import androidx.compose.material.Text
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.OutlinedButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.navigation.NavHostController
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.Sp
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.log
import com.hyperether.goodjob.models.CompletionReportStatus
import com.hyperether.goodjob.models.JobStatus
import com.hyperether.goodjob.models.Note
import com.hyperether.goodjob.models.Step
import com.hyperether.goodjob.navigation.*
import com.hyperether.goodjob.repository.Mapper
import com.hyperether.goodjob.repository.remote.model.CompletionReportResponse
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.about_job
import com.hyperether.goodjob.resources.are_you_sure
import com.hyperether.goodjob.resources.back_arrow
import com.hyperether.goodjob.resources.cancel
import com.hyperether.goodjob.resources.check_mark
import com.hyperether.goodjob.resources.company
import com.hyperether.goodjob.resources.completed
import com.hyperether.goodjob.resources.completion_report
import com.hyperether.goodjob.resources.confirmation
import com.hyperether.goodjob.resources.contact_information
import com.hyperether.goodjob.resources.delete
import com.hyperether.goodjob.resources.details
import com.hyperether.goodjob.resources.due_date
import com.hyperether.goodjob.resources.edit
import com.hyperether.goodjob.resources.end_time
import com.hyperether.goodjob.resources.estimated_duration
import com.hyperether.goodjob.resources.files
import com.hyperether.goodjob.resources.job_details
import com.hyperether.goodjob.resources.location_details
import com.hyperether.goodjob.resources.mark_step_completed
import com.hyperether.goodjob.resources.mark_step_pending
import com.hyperether.goodjob.resources.minutes
import com.hyperether.goodjob.resources.no_completion_report
import com.hyperether.goodjob.resources.no_information
import com.hyperether.goodjob.resources.no_tasks_text_employee
import com.hyperether.goodjob.resources.report_will_appear
import com.hyperether.goodjob.resources.schedule
import com.hyperether.goodjob.resources.site
import com.hyperether.goodjob.resources.start_date
import com.hyperether.goodjob.resources.start_time
import com.hyperether.goodjob.resources.status
import com.hyperether.goodjob.resources.steps
import com.hyperether.goodjob.resources.task_empty
import com.hyperether.goodjob.resources.trash
import com.hyperether.goodjob.scenes.addNew.StepInputFields
import com.hyperether.goodjob.scenes.components.PopUpDialog
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.pointerCursorIfEnabled
import com.hyperether.goodjob.scenes.jobs.components.JobDetailsAssigneesView
import com.hyperether.goodjob.scenes.jobs.components.JobDetailsHeaderView
import com.hyperether.goodjob.scenes.jobs.components.JobDetailsView
import com.hyperether.goodjob.scenes.register.FilledButton
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.Green
import com.hyperether.goodjob.theme.LandingPageMobileText
import com.hyperether.goodjob.theme.TextColor
import com.hyperether.goodjob.util.Constants
import com.hyperether.goodjob.util.DateTimeUtil
import com.hyperether.goodjob.util.DocumentType
import com.hyperether.goodjob.util.JobStatusMap
import com.hyperether.goodjob.util.JobStatusMapEmployee
import com.hyperether.goodjob.util.UploadManager
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun JobDetails(
    isMobile: Boolean,
    jobId: String,
    viewModel: JobDetailsViewModel,
    navHostController: NavHostController,
    onOpenPdf: (String) -> Unit,
    onUploadDocumentClick: (String, DocumentType) -> Unit
) {

    viewModel.jobStatusMap = if (viewModel.isEmployee()) JobStatusMapEmployee() else JobStatusMap()

    val isAboutJobView = remember { mutableStateOf(true) }
    var selectedButtonIndex by remember { mutableStateOf(0) }
    var percentCompleted by remember { mutableStateOf(0) }
    var submitFormShown by remember { mutableStateOf(false) }

    val job by viewModel.jobDetails.collectAsState()
    val contact by viewModel.contact.collectAsState()
    val images = viewModel.jobFilesImagePainters.collectAsState()
    val documents = viewModel.jobFilesPdfs.collectAsState()
    log.d("JobDetails") { "JobDetails recompose. documents: ${documents.value.size}" }

    DisposableEffect(Unit) {
        onDispose {
            viewModel.clearData()
        }
    }

    LaunchedEffect(Unit) {
        log.d("JobDetails") { "JobDetails recompose. loadJobDetails: $jobId" }
        viewModel.loadJobDetails(jobId)
    }
    LaunchedEffect(job) {
        UploadManager.downloadJobFiles(job, viewModel.repository, showLoader = null)
    }
    LaunchedEffect(images, documents) {
        viewModel.loadRemoteData()
    }

    println(job.toString())
    println(contact.toString())

    if (isMobile) {

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .pointerInput(Unit) {
                    detectTapGestures {
                        // Same as onMenuClick
                        if (viewModel.showNoteEditDeletePopUpMenu.value) {
                            viewModel.showNoteEditDeletePopUpMenu.value = false
                            viewModel.selectedNoteId.value = null
                        }
                    }
                }
        ) {
            Column {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = Dp(16f), vertical = Dp(20f))
                ) {
                    Image(
                        painter = painterResource(Res.drawable.back_arrow),
                        contentDescription = "",
                        modifier = Modifier
                            .clickable {
                                navHostController.navigateUp()
                            }
                    )

                    Text(
                        text = stringResource(Res.string.job_details),
                        fontSize = Sp(18f),
                        color = Color.Black,
                        textAlign = TextAlign.Center,
                        modifier = Modifier
                            .weight(1f)
                            .padding(start = Dp(16f))
                    )

                    Row(
                        horizontalArrangement = Arrangement.End,
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier
                            .wrapContentWidth()
                            .padding(start = Dp(8f))
                    ) {
                        val jobCompleted =
                            job?.status?.let { it == JobStatus.completed.name } == true
                        if (!viewModel.isEmployee() && !jobCompleted) {
                            Image(
                                painter = painterResource(Res.drawable.edit),
                                contentDescription = "",
                                modifier = Modifier
                                    .padding()
                                    .clickable {
                                        navHostController.navigate(AddNewJob(jobId))
                                    }
                            )
                        }
                    }
                }
                Divider(
                    modifier = Modifier.height(Dp(2f))
                        .background(Color.LightGray.copy(alpha = 0.1f))
                )
                Column(
                    modifier = Modifier
                        .background(Color.LightGray.copy(alpha = 0.2f))
                        .padding(Dp(8f)),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth().height(Dp(40f)),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Box(
                            modifier = Modifier
                                .weight(0.5f)
                                .fillMaxSize()
                                .clickable(
                                    interactionSource = remember { MutableInteractionSource() },
                                    indication = null
                                ) {
                                    isAboutJobView.value = true
                                },
                            contentAlignment = Alignment.Center
                        ) {
                            androidx.compose.material3.Text(
                                text = stringResource(Res.string.about_job),
                                color = if (isAboutJobView.value) BlueApp else Color.Gray,
                                fontSize = Sp(16f),
                                textAlign = TextAlign.Center
                            )
                        }
                        Box(
                            modifier = Modifier
                                .weight(0.5f)
                                .fillMaxSize()
                                .clickable(
                                    interactionSource = remember { MutableInteractionSource() },
                                    indication = null
                                ) {
                                    isAboutJobView.value = false
                                },
                            contentAlignment = Alignment.Center
                        ) {
                            androidx.compose.material3.Text(
                                text = stringResource(Res.string.completion_report),
                                color = if (isAboutJobView.value) Color.Gray else BlueApp,
                                fontSize = Sp(16f),
                                textAlign = TextAlign.Center
                            )
                        }
                    }
                }
                Box(
                    modifier = Modifier
                        .height(Dp(2f))
                        .fillMaxWidth(0.5f)
                        .background(if (isAboutJobView.value) BlueApp else BlueApp)
                        .align(if (isAboutJobView.value) Alignment.Start else Alignment.End)
                )

                if (isAboutJobView.value) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(start = Dp(1f), end = Dp(1f), top = Dp(10f)),
                        horizontalArrangement = Arrangement.SpaceEvenly,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        val buttons = listOf(
                            stringResource(Res.string.details),
                            stringResource(Res.string.steps),
                            stringResource(Res.string.files)
                        )

                        buttons.forEachIndexed { index, label ->
                            Box(
                                modifier = Modifier
                                    .weight(1f)
                                    .padding(Dp(5f))
                                    .border(Dp(1f), Color.LightGray, RoundedCornerShape(20))
                                    .background(
                                        color = if (selectedButtonIndex == index) BlueApp else Color.Transparent,
                                        shape = RoundedCornerShape(20)
                                    )
                                    .clickable(
                                        interactionSource = remember { MutableInteractionSource() },
                                        indication = null
                                    ) { selectedButtonIndex = index },
                                contentAlignment = Alignment.Center
                            ) {
                                Text(
                                    text = label,
                                    color = if (selectedButtonIndex == index) Color.White else Color.Gray,
                                    modifier = Modifier.padding(vertical = Dp(12f))
                                )
                            }
                        }
                    }
                    if (selectedButtonIndex == 0) {
                        Column(
                            modifier = Modifier
                                .fillMaxSize()
                                .verticalScroll(rememberScrollState())
                                .disableMouseDragScrollOnWeb()
                        ) {
                            JobDetailsHeaderView(isMobile, job, viewModel)
                            JobDetailsAssigneesView(job)
                            JobDetailsView(
                                stringResource(Res.string.contact_information),
                                firstDetailText = viewModel.site.value?.personName ?: "",
                                firstDescriptionText = "",
                                secondDetailText = viewModel.site.value?.personPhone ?: "",
                                secondDescriptionText = "",
                                thirdDetailText = viewModel.site.value?.personEmail ?: "",
                                thirdDescriptionText = ""
                            )
                            JobDetailsView(
                                stringResource(Res.string.location_details),
                                firstDetailText = viewModel.site.value?.addressObject?.address
                                    ?: "",
                                firstDescriptionText = "",
                                secondDescriptionText = stringResource(Res.string.site) + ": ",
                                secondDetailText = viewModel.site.value?.siteName
                                    ?: "",
                                thirdDescriptionText = stringResource(Res.string.company) + ": ",
                                thirdDetailText = viewModel.contact.value?.name ?: ""
                            )
                            JobDetailsView(
                                title = stringResource(Res.string.schedule),
                                firstDescriptionText = stringResource(Res.string.start_date) + ": ",
                                firstDetailText = if (job?.startDate?.isNotEmpty() == true) job?.startDate?.let {
                                    DateTimeUtil.formatJobDetailsDate(
                                        it
                                    )
                                } ?: stringResource(Res.string.no_information)
                                else stringResource(Res.string.no_information),
                                secondDetailText = if (job?.dueDate?.isNotEmpty() == true) job?.dueDate?.let {
                                    DateTimeUtil.formatJobDetailsDate(
                                        it
                                    )
                                } ?: stringResource(Res.string.no_information)
                                else stringResource(Res.string.no_information),
                                secondDescriptionText = stringResource(Res.string.due_date) + ": ",

                                thirdDetailText = if (job?.start_at?.isNotEmpty() == true) job?.start_at
                                    ?: stringResource(Res.string.no_information) else stringResource(
                                    Res.string.no_information
                                ),
                                thirdDescriptionText = stringResource(Res.string.start_time) + ": ",
                                lastDetailText = if (job?.end_at?.isNotEmpty() == true) job?.end_at
                                    ?: stringResource(Res.string.no_information) else stringResource(
                                    Res.string.no_information
                                ),
                                lastDescriptionText = stringResource(Res.string.end_time) + ": ",
                            )
                            Spacer(modifier = Modifier.height(Dp(20f)))
                        }

                    } else if (selectedButtonIndex == 1) {
                        val markAsDoneEnabled = viewModel.isUserAssignedToJob(job)
                                || viewModel.isAdmin()
                        Column(
                            modifier = Modifier
                                .verticalScroll(rememberScrollState())
                                .disableMouseDragScrollOnWeb()
                        ) {
                            val steps = job?.steps.orEmpty().filterNotNull()
                            val totalSteps = steps.size
                            val completedSteps =
                                steps.count { it.stepStatus == Constants.STEP_STATUS_COMPLETED }
                            val percentCompleted =
                                if (totalSteps > 0) (completedSteps * 100) / totalSteps else 0
                            val showAddTask = (!(job?.status == JobStatus.completed.name ||
                                    job?.status == JobStatus.pendingApproval.name) && !viewModel.isEmployee())
                            val showTaskPlaceholder = (!(job?.status == JobStatus.completed.name ||
                                    job?.status == JobStatus.pendingApproval.name) && viewModel.isEmployee())

                            if (steps.isNotEmpty()) {
                                if (steps[0].stepTitle?.isNotEmpty() == true) {
                                    Column {
                                        Spacer(modifier = Modifier.height(Dp(15f)))
                                        if (viewModel.isUserAssignedToJob(job)) {
                                            LinearProgressBar(percentCompleted = percentCompleted)
                                        } else {
                                            Text(
                                                text = "${percentCompleted}% " + stringResource(Res.string.completed),
                                                color = Green,
                                                fontWeight = FontWeight.W900,
                                                fontSize = Sp(16f),
                                                modifier = Modifier.padding(start = Dp(16f))
                                            )
                                        }
                                        Spacer(modifier = Modifier.height(Dp(15f)))

                                        Column {
                                            if (steps.isNotEmpty()) {
                                                steps.filter { it.stepTitle?.isNotEmpty() == true }
                                                    .forEachIndexed { index, step ->
                                                        step.let {
                                                            val stepCounter =
                                                                remember { mutableStateOf(index + 1) }

                                                            StepsItem(
                                                                isEmployee = viewModel.isEmployee(),
                                                                step = step,
                                                                markAsDoneEnabled = markAsDoneEnabled,
                                                                number = stepCounter,
                                                                onStepUpdateCallback = { stepState ->
                                                                    step.stepStatus = stepState
                                                                    viewModel.updateJobStepsStatus(
                                                                        jobId,
                                                                        steps = steps,
                                                                        onSuccess = {},
                                                                        onError = {})
                                                                },
                                                                onStepDeleteCallback = { step ->
                                                                    val updatedSteps =
                                                                        steps.filter { it != step }
                                                                    job?.id?.let {
                                                                        val jobRequest =
                                                                            Mapper().toJobUpdateRequest(
                                                                                job!!
                                                                            )
                                                                        jobRequest.steps =
                                                                            updatedSteps
                                                                        viewModel.updateJob(
                                                                            it,
                                                                            job = jobRequest,
                                                                            onSuccess = {},
                                                                            onError = {}
                                                                        )
                                                                    }
                                                                })
                                                        }
                                                    }
                                            }
                                        }

                                    }
                                }
                                if (showAddTask) {
                                    StepInputFields {
                                        viewModel.addStepToJob(step = it)
                                    }
                                }
                            } else {
                                Column(
                                    modifier = Modifier
                                        .fillMaxSize()
                                        .padding(16f.toScaleDp()),
                                    horizontalAlignment = Alignment.CenterHorizontally
                                ) {
                                    if (showAddTask) {
                                        Spacer(modifier = Modifier.height(12.toScaleDp()))
                                        Text(
                                            text = stringResource(Res.string.task_empty),
                                            fontSize = 16.toScaleSp(),
                                            textAlign = TextAlign.Center
                                        )
                                        Spacer(modifier = Modifier.height(12.toScaleDp()))
                                        StepInputFields {
                                            viewModel.addStepToJob(step = it)
                                        }
                                    } else if (showTaskPlaceholder) {
                                        Spacer(modifier = Modifier.height(12.toScaleDp()))
                                        Text(
                                            text = stringResource(Res.string.no_tasks_text_employee),
                                            fontSize = 16.toScaleSp(),
                                            textAlign = TextAlign.Center
                                        )
                                        Spacer(modifier = Modifier.height(12.toScaleDp()))
                                    }
                                }
                            }
                            Spacer(modifier = Modifier.height(20.toScaleDp()))
                        }
                    } else if (selectedButtonIndex == 2) {
                        Column(
                            modifier = Modifier
                                .verticalScroll(rememberScrollState())
                                .disableMouseDragScrollOnWeb()
                        ) {
                            job?.let {
                                NotesAndDocumentsView(
                                    images = images.value,
                                    documents = documents.value,
                                    job = it,
                                    isEmployee = viewModel.isEmployee(),
                                    onAddNoteClick = {
                                        viewModel.showNotePopUp.value = true
                                    },
                                    onOpenPdfClick = { fileId ->
                                        onOpenPdf(fileId)
                                    },
                                    onDeleteFileClick = { fileId ->
                                        viewModel.selectedFileId.value = fileId
                                        viewModel.selectedJob.value = it
                                        viewModel.showAreYouSurePopUpDeleteFile.value = true
                                    },
                                    onDeleteImageClick = { imageName ->
                                        viewModel.selectedImageFileId.value = imageName
                                        viewModel.selectedJob.value = it
                                        viewModel.showAreYouSurePopUpDeleteImage.value = true
                                    },
                                    onMenuClicked = { note: Note ->
                                        if (viewModel.selectedNoteId.value == note._id && viewModel.showNoteEditDeletePopUpMenu.value) {
                                            viewModel.showNoteEditDeletePopUpMenu.value = false
                                            viewModel.selectedNoteId.value = null
                                        } else {
                                            viewModel.selectedNoteId.value = note._id
                                            viewModel.noteToEditOrDelete.value = note
                                            viewModel.showNoteEditDeletePopUpMenu.value = true
                                        }
                                    },
                                    onEditNote = { note ->
                                        viewModel.noteInput.value = note.noteText.orEmpty()
                                        viewModel.showNotePopUp.value = true
                                        viewModel.isEditSelectedNote.value = true
                                        viewModel.selectedNoteId.value = note._id
                                    },
                                    onDeleteNote = {
                                        viewModel.showAreYouSurePopUpDeleteNote.value = true
                                        viewModel.selectedNoteId.value = null
                                    },
                                    isPopupVisible = { note ->
                                        viewModel.selectedNoteId.value == note._id && viewModel.showNoteEditDeletePopUpMenu.value
                                    },
                                    onAddFileClick = { jobId ->
                                        onUploadDocumentClick(jobId, DocumentType.JOB_FILE)
                                    },
                                    onOpenImageClick = { painter ->
                                        viewModel.onOpenImageClick(painter)
                                    }
                                )
                            }
                        }
                    }
                } else {
                    Column(
                        modifier = Modifier
                            .verticalScroll(rememberScrollState())
                            .disableMouseDragScrollOnWeb()
                    ) {
                        var report: CompletionReportResponse? = null
                        job?.completionReport?.let {
                            report =
                                Mapper().jsonAsObject<CompletionReportResponse>(
                                    job?.completionReport
                                )
                        }
                        if (report == null && !submitFormShown) {
                            Column(
                                modifier = Modifier.padding(
                                    start = Dp(16f),
                                    end = Dp(16f),
                                    top = Dp(50f)
                                )
                                    .fillMaxWidth(),
                                horizontalAlignment = Alignment.CenterHorizontally
                            ) {
                                Text(
                                    text = stringResource(Res.string.no_completion_report),
                                    fontSize = Sp(24f),
                                    color = Color.Black,
                                    fontWeight = FontWeight.Bold,
                                    textAlign = TextAlign.Center

                                )
                                Spacer(modifier = Modifier.height(Dp(15f)))
                                Text(
                                    text = stringResource(Res.string.report_will_appear),
                                    fontSize = Sp(16f),
                                    textAlign = TextAlign.Center
                                )
                            }
                        }

                        job?.let {
                            var report: CompletionReportResponse? = null
                            job?.completionReport?.let {
                                report =
                                    Mapper().jsonAsObject<CompletionReportResponse>(job?.completionReport)
                            }
                            if (viewModel.isUserAssignedToJob(job)) {
                                if (report == null || report?.status == CompletionReportStatus.rejected.name) {
                                    if (report != null) {
                                        viewModel.damageState.value =
                                            report?.damage == true
                                        viewModel.damageTextState.value =
                                            report?.damageDescription ?: ""
                                        viewModel.healthAndSafetyState.value =
                                            report?.healthAndSafety == true
                                        viewModel.healthAndSafetyTextState.value =
                                            report?.unmetSafetyRequirements ?: ""
                                        viewModel.correctFunctionalityState.value =
                                            report?.correctFunctionality == true
                                        viewModel.correctFunctionalityTextState.value =
                                            report?.reasonForIncompleteInspection ?: ""
                                        viewModel.additionalNotesText.value =
                                            report?.additionalNotes ?: ""
                                        viewModel.clientFeedbackText.value =
                                            report?.clientFeedback ?: ""
                                        viewModel.filesList.clear()
                                        report?.files?.let {
                                            viewModel.filesList.addAll(it)
                                        }
                                    }
                                    submitFormShown = true
                                    CompletionReportSubmit(
                                        viewModel,
                                        navHostController,
                                        job!!,
                                        report,
                                        onUploadDocumentClick
                                    )
                                } else {
                                    CompletionReportOverview(
                                        viewModel,
                                        navHostController,
                                        job!!,
                                        report,
                                        onOpenPdf
                                    )
                                }
                            } else {
                                CompletionReportOverview(
                                    viewModel,
                                    navHostController,
                                    job!!,
                                    report,
                                    onOpenPdf
                                )
                            }
                        } ?: run {
                            CompletionReportOverview(
                                viewModel,
                                navHostController,
                                job!!,
                                report,
                                onOpenPdf
                            )
                        }
                    }
                }
            }
            if (viewModel.showPreviewImage.value) {
                viewModel.previewImageFile.value?.let {
                    FullScreenImagePreview(
                        imagePainter = it,
                        onDismiss = {
                            viewModel.showPreviewImage.value = false
                            viewModel.previewImageFile.value = null
                        }
                    )
                }
            }
        }
    } else {
        SelectionContainer {
            JobDetailsWeb(
                isMobileView = isMobile,
                navHostController = navHostController,
                viewModel = viewModel,
                job = job,
                jobId = jobId,
                contact = contact,
                images = images.value,
                documents = documents.value,
                onOpenPdf = onOpenPdf,
                onUploadDocumentClick = onUploadDocumentClick
            )
        }
    }
    JobPopups(
        jobId,
        job,
        viewModel,
        navHostController
    )
}

@Composable
fun StepsItem(
    isEmployee: Boolean,
    step: Step,
    markAsDoneEnabled: Boolean,
    number: MutableState<Int>,
    onStepUpdateCallback: (String) -> Unit,
    onStepDeleteCallback: (Step) -> Unit = {}
) {

    var showDeleteStepPopup by rememberSaveable { mutableStateOf(false) }

    Row(
        verticalAlignment = Alignment.Top,
        horizontalArrangement = Arrangement.SpaceAround,
    ) {
        Column(
            modifier = Modifier
                .weight(2f)
                .padding(vertical = 8.dp, horizontal = 16.dp)
        ) {
            val isCompleted = step.stepStatus.equals(other = "Completed", ignoreCase = true)

            step.stepTitle?.let {
                Row(
                    modifier = if (!getPlatformChecker().isMobile()) Modifier.padding(
                        horizontal = Dp(8f),
                        vertical = Dp(4f)
                    ) else Modifier
                ) {
                    NumberCircle(
                        step = step,
                        number = number.value,
                        markAsDoneEnabled = markAsDoneEnabled,
                    )
                    Spacer(modifier = Modifier.width(Dp(15f)))
                    Column {
                        Text(
                            text = it,
                            color = Color.DarkGray,
                            fontWeight = FontWeight.Bold,
                            fontSize = Sp(16f),
                            textDecoration = if (!markAsDoneEnabled) TextDecoration.None else {
                                if (step.stepStatus == Constants.STEP_STATUS_COMPLETED)
                                    TextDecoration.LineThrough else TextDecoration.None
                            }
                        )
                        step.stepDescription?.let {
                            Text(
                                modifier = Modifier.padding(vertical = Dp(4f)),
                                text = it,
                                color = TextColor,
                                fontWeight = FontWeight.Normal,
                                fontSize = Sp(14f),
                                textDecoration = if (!markAsDoneEnabled) TextDecoration.None else {
                                    if (step.stepStatus == Constants.STEP_STATUS_COMPLETED)
                                        TextDecoration.LineThrough else TextDecoration.None
                                }
                            )
                        }
                        Row(
                            modifier = if (!getPlatformChecker().isMobile()) Modifier.padding(
                                vertical = Dp(4f)
                            ) else Modifier
                        ) {
                            Text(
                                text = "${stringResource(Res.string.estimated_duration)}:",
                                color = Color.LightGray,
                                fontWeight = FontWeight.Normal,
                                fontSize = Sp(14f),
                                textDecoration = if (!markAsDoneEnabled) TextDecoration.None else {
                                    if (step.stepStatus == Constants.STEP_STATUS_COMPLETED)
                                        TextDecoration.LineThrough else TextDecoration.None
                                },
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                            Spacer(modifier = Modifier.width(Dp(5f)))
                            step.estimatedDuration?.let {
                                Text(
                                    text = it.toString() + " " + stringResource(Res.string.minutes),
                                    color = TextColor,
                                    fontWeight = FontWeight.Bold,
                                    fontSize = Sp(14f),
                                    textDecoration = if (!markAsDoneEnabled) TextDecoration.None else {
                                        if (step.stepStatus == Constants.STEP_STATUS_COMPLETED)
                                            TextDecoration.LineThrough else TextDecoration.None
                                    },
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                            }
                        }
                        if (!markAsDoneEnabled) {
                            Row(
                                modifier = if (!getPlatformChecker().isMobile()) Modifier.padding(
                                    vertical = Dp(4f)
                                ) else Modifier,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(
                                    text = "${stringResource(Res.string.status)}:",
                                    color = Color.LightGray,
                                    fontWeight = FontWeight.Normal,
                                    fontSize = Sp(14f),
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                                Spacer(modifier = Modifier.width(Dp(5f)))
                                if (step.stepStatus == Constants.STEP_STATUS_COMPLETED) { // TODO add enum for step status
                                    Image(
                                        painter = painterResource(Res.drawable.check_mark),
                                        contentDescription = "Completed",
                                        modifier = Modifier.size(Dp(16f)),
                                        colorFilter = if (isCompleted) ColorFilter.tint(Green) else ColorFilter.tint(
                                            BlueApp
                                        )
                                    )
                                }

                                Spacer(modifier = Modifier.width(Dp(5f)))
                                Text(
                                    text = step.stepStatus?.replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }
                                        ?: stringResource(Res.string.completed).replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() },
                                    color = if (isCompleted) Green else BlueApp,
                                    fontWeight = FontWeight.Bold,
                                    fontSize = Sp(14f),
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                            }
                        }
                    }
                }
            }


            Spacer(modifier = Modifier.height(Dp(15f)))

            if (markAsDoneEnabled) {
                Row(
                    modifier = if (!getPlatformChecker().isMobile()) Modifier.padding(
                        horizontal = Dp(8f),
                        vertical = Dp(4f)
                    ) else Modifier,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    if (step.stepStatus != Constants.STEP_STATUS_COMPLETED) {
                        FilledButton(
                            onClick = {
                                onStepUpdateCallback(Constants.STEP_STATUS_COMPLETED)
                            },
                            modifier = Modifier.padding(
                                start = Dp(16f),
                                end = Dp(16f),
                                top = Dp(16f)
                            ),
                            text = stringResource(Res.string.mark_step_completed),
                            isEnabled = true
                        )
                    } else {
                        OutlinedButton(
                            onClick = { onStepUpdateCallback(Constants.STEP_STATUS_PENDING) },
                            border = BorderStroke(Dp(1f), BlueApp),
                            shape = RoundedCornerShape(50),
                            colors = ButtonDefaults.outlinedButtonColors(
                                contentColor = Color.White, containerColor = Color.Transparent
                            ),
                            modifier = Modifier
                                .padding(start = Dp(16f), end = Dp(16f), top = Dp(16f))
                                .fillMaxWidth()
                                .height(Dp(50f))
                                .pointerHoverIcon(PointerIcon.Hand)
                        ) {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Text(
                                    text = stringResource(Res.string.mark_step_pending),
                                    color = BlueApp,
                                    fontSize = Sp(15f),
                                    textAlign = TextAlign.Center
                                )
                            }
                        }
                    }
                }
                Spacer(modifier = Modifier.height(Dp(16f)))
            }
        }
        if (!isEmployee) {
            IconButton(
                modifier = Modifier
                    .padding(horizontal = 8.dp)
                    .pointerCursorIfEnabled(true),
                onClick = {
                    showDeleteStepPopup = true
                }) {
                DisableSelection {
                    Image(
                        painter = painterResource(Res.drawable.trash),
                        contentDescription = null,
                        modifier = Modifier.size(20.toScaleDp())
                    )
                }
            }
        }
    }

    if (showDeleteStepPopup) {
        PopUpDialog(
            title = stringResource(Res.string.confirmation),
            message = stringResource(Res.string.are_you_sure),
            onDismiss = { showDeleteStepPopup = false },
            negativeBtnText = stringResource(Res.string.cancel),
            onNegativeBtnClicked = { showDeleteStepPopup = false },
            positiveBtnText = stringResource(Res.string.delete),
            onPositiveBtnClicked = {
                onStepDeleteCallback(step)
                showDeleteStepPopup = false
            }
        )
    }
}

@Composable
fun NumberCircle(
    step: Step,
    number: Int,
    markAsDoneEnabled: Boolean
) {
    var currentNumber by remember { mutableStateOf(number) }
    val isCompleted = step.stepStatus.equals(other = "Completed", ignoreCase = true)

    Box(
        contentAlignment = Alignment.Center,
        modifier = Modifier
            .size(Dp(25f))
            .border(
                width = Dp(1f), color = if (isCompleted) Green else BlueApp,
                shape = CircleShape
            )
            .background(
                color = if (isCompleted) Green else Color.Transparent, shape = CircleShape
            )
    ) {
        if (isCompleted && markAsDoneEnabled) {
            Image(
                painter = painterResource(Res.drawable.check_mark),
                contentDescription = "Completed",
                modifier = Modifier.size(Dp(16f)),
                colorFilter = ColorFilter.tint(Color.White)
            )
        } else {
            Text(
                text = currentNumber.toString().padStart(2, '0'),
                color = if (isCompleted) Color.White else BlueApp,
                fontWeight = FontWeight.Normal,
                lineHeight = Sp(14f),
                fontSize = Sp(12f)
            )
        }
    }
}

@Composable
fun LinearProgressBar(percentCompleted: Int) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = Dp(16f))
    ) {
        Text(
            text = "$percentCompleted%",
            color = Green,
            fontWeight = FontWeight.Bold,
            fontSize = Sp(16f)
        )
        Spacer(modifier = Modifier.height(Dp(4f)))
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(Dp(10f))
                .clip(RoundedCornerShape(50))
                .background(LandingPageMobileText)
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth(percentCompleted / 100f)
                    .height(Dp(10f))
                    .clip(RoundedCornerShape(50))
                    .background(Green)
            )
        }
    }
}
